import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { GAP_CLASS, type Align, type Gap, type Justify } from "./tokens";

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  /** Espacio entre hijos · escala nombrada (default `"md"`) o número en px. */
  gap?: Gap;
  align?: Align;
  justify?: Justify;
}

/**
 * Reemplazo de `<Stack>` de Mantine · columna flex con `gap`. Layout puro,
 * sin decisiones de diseño propias · por eso conserva las mismas props
 * (`gap`/`align`/`justify`) que el original, para que migrar un call-site
 * sea cambiar el import, no reescribir JSX.
 */
export const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ gap = "md", align, justify, className, style, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex flex-col",
        typeof gap === "string" ? GAP_CLASS[gap] : undefined,
        className
      )}
      style={{
        alignItems: align,
        justifyContent: justify,
        ...(typeof gap === "number" ? { gap } : undefined),
        ...style,
      }}
      {...props}
    />
  )
);
Stack.displayName = "Stack";
